import React from "react";
import NavLink from "./navLink";
import {Link} from "react-router-dom";

const Nav = props => {
  const { selApp, userId } = props;

  const navs = props.navs;
  const noUserNavs = props.noUserNavs;

    return (
      <ul id="nav">
        {(userId ? navs : noUserNavs).map(nav => (
          !nav.external ?
          <NavLink
            key={nav.navId}
            pageId={props.pageId}
            nav={nav}
            selApp={selApp}
          /> : 
          <li className="external-nav-link">
            <Link to={nav.to} target="_blank">
              <span>{nav.label}</span>
              <i className="material-icons" style={{textDecoration: "none"}}>open_in_new</i>
            </Link>
          </li>
        ))}
      </ul>
    );
};

export default Nav;
